/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createProduct = /* GraphQL */ `
  mutation CreateProduct(
    $input: CreateProductInput!
    $condition: ModelProductConditionInput
  ) {
    createProduct(input: $input, condition: $condition) {
      id
      brand_name
      product_name
      registered_region
      style
      price_ex_vat
      bottles_per_year
      year_of_production
      container_size_cl
      abv_percentage
      tags
      product_image
      other_images
      techSheetDescription
      techSheetProductType
      techSheetSoil
      techSheetProductionArea
      techSheetFormat
      techSheetAgingCapacity
      techSheetYearOfPlanting
      techSheetVinification
      techSheetAppearance
      techSheetNose
      techSheetPalate
      techSheetPairings
      techSheetServingTemperatureMin
      techSheetServingTemperatureMax
      techSheetCertifications
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const updateProduct = /* GraphQL */ `
  mutation UpdateProduct(
    $input: UpdateProductInput!
    $condition: ModelProductConditionInput
  ) {
    updateProduct(input: $input, condition: $condition) {
      id
      brand_name
      product_name
      registered_region
      style
      price_ex_vat
      bottles_per_year
      year_of_production
      container_size_cl
      abv_percentage
      tags
      product_image
      other_images
      techSheetDescription
      techSheetProductType
      techSheetSoil
      techSheetProductionArea
      techSheetFormat
      techSheetAgingCapacity
      techSheetYearOfPlanting
      techSheetVinification
      techSheetAppearance
      techSheetNose
      techSheetPalate
      techSheetPairings
      techSheetServingTemperatureMin
      techSheetServingTemperatureMax
      techSheetCertifications
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const deleteProduct = /* GraphQL */ `
  mutation DeleteProduct(
    $input: DeleteProductInput!
    $condition: ModelProductConditionInput
  ) {
    deleteProduct(input: $input, condition: $condition) {
      id
      brand_name
      product_name
      registered_region
      style
      price_ex_vat
      bottles_per_year
      year_of_production
      container_size_cl
      abv_percentage
      tags
      product_image
      other_images
      techSheetDescription
      techSheetProductType
      techSheetSoil
      techSheetProductionArea
      techSheetFormat
      techSheetAgingCapacity
      techSheetYearOfPlanting
      techSheetVinification
      techSheetAppearance
      techSheetNose
      techSheetPalate
      techSheetPairings
      techSheetServingTemperatureMin
      techSheetServingTemperatureMax
      techSheetCertifications
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const updateProductSampleRequest = /* GraphQL */ `
  mutation UpdateProductSampleRequest(
    $input: UpdateProductSampleRequestInput!
    $condition: ModelProductSampleRequestConditionInput
  ) {
    updateProductSampleRequest(input: $input, condition: $condition) {
      id
      distributor_name
      distributor_code
      distributor_phone
      distributor_email
      brand_name
      product_name
      price_ex_vat
      registered_region
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteProductSampleRequest = /* GraphQL */ `
  mutation DeleteProductSampleRequest(
    $input: DeleteProductSampleRequestInput!
    $condition: ModelProductSampleRequestConditionInput
  ) {
    deleteProductSampleRequest(input: $input, condition: $condition) {
      id
      distributor_name
      distributor_code
      distributor_phone
      distributor_email
      brand_name
      product_name
      price_ex_vat
      registered_region
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createProductSampleRequest = /* GraphQL */ `
  mutation CreateProductSampleRequest(
    $input: CreateProductSampleRequestInput!
    $condition: ModelProductSampleRequestConditionInput
  ) {
    createProductSampleRequest(input: $input, condition: $condition) {
      id
      distributor_name
      distributor_code
      distributor_phone
      distributor_email
      brand_name
      product_name
      price_ex_vat
      registered_region
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
